import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import EMTLevel from "../../components/emtLevel";
import MyLink from "../../components/myLink";
import Note from "../../components/note";
import Caution from "../../components/caution";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Note id="note-1" alignment="left" mdxType="Note">
  Naloxone should only be administered in suspected overdose patients
  with inadequate respirations and respiratory rate. 
  <br /><br />
  Treatment should progress toward the restoration of adequate respirations. 
  <br /><br />
  Patients with inadequate respiratory rates may need to be ventilated until
  their respiratory rate increases.
    </Note>
    <br />
    <EMTLevel level="first-responder" mdxType="EMTLevel">
  <EMTLevel level="basic" mdxType="EMTLevel">
    <ul>
      <li>
        <MyLink to="/sections/1/1.0-routine-patient-care" mdxType="MyLink">
          1.0 Routine Patient Care
        </MyLink>
      </li>
      <li>Naloxone 2 mg-4 mg via Nasal Atomizer (IN) or 0.4 mg via auto-injector (IM).</li>
      <li>If no response after 3-5 minutes, give second dose.</li>
      <li>First Responders may only administer if trained and authorized.</li>
      <li>If suspected or confirmed hypoglycemia, treat per protocol. </li>
    </ul>
  </EMTLevel>
    </EMTLevel>
    <EMTLevel level="advanced" mdxType="EMTLevel">
  Naloxone
  <ul>
    <li>
      <strong>ADULT: </strong>
      0.4-4 mg IV/IO/IM/IN. May be repeated as indicated.
    </li>
    <li>
      <strong>PEDI: </strong>
      0.1 mg/kg IV/IO/IM/IN May be repeated as indicated.
    </li>
  </ul>
    </EMTLevel>
    <EMTLevel level="paramedic" medControl={true} mdxType="EMTLevel">
  <ul>
    <li>
      Calcium chloride 10% 20 mg/kg IV/IO administer slowly over 5 minutes to a
      maximum dose of 1 gram. (e.g., for calcium blocker toxicity).
    </li>
    <li>
      Sodium bicarbonate 0.5 – 1 mEq/Kg IV/IO (e.g. TCA or Aspirin overdose).
    </li>
    <li>
      Atropine:
      <ul>
        <li>
          <strong>ADULT: </strong>
          2- 5 mg IV/IO (e.g., organophosphate poisoning
          management).
        </li> 
        <li>
          <strong>PEDI: </strong> 
          0.02 mg/kg IV/IO.
        </li>
      </ul>
    </li>
    <li>
      Albuterol 2.5-3 mg by nebulizer (e.g., bronchospasm management).
    </li>
    <li>
      Furosemide
      <ul>
        <li>
          <strong>ADULT: </strong>
          40 mg IV/IO (e.g., pulmonary edema management).</li>
        <li>
          <strong>PEDI: </strong> 0.5 mg/kg IV/IO
        </li>
      </ul>
    </li>
    <li>
      Midazolam
      <ul>
        <li>
          <strong>ADULT: </strong>
          2 – 6 mg IV/IO/IM/IN.
        </li>
        <li>
          <strong>PEDI: </strong>
          0.05mg/kg IV/IO/IM/IN.
        </li>
      </ul>
    </li>
    <li>
      <strong>Amyl nitrite: </strong> administer vapors of a crushed inhalant or pearl
      under the patients nose for 15 out of every 30 thirty seconds with
      intermittent 100% oxygen administration.
    </li>
    <li>CYANIDE ANTIDOTE KIT if available by EMS service and/or industrial site:</li>
    <li>Two (2) amyl nitrite inhalants.</li>
    <li>
      3% sodium nitrite (stop Amyl nitrite):
      <ul>
        <li>
          <strong>ADULT: </strong>
          10 mL slow IV/IO over 2-4 minutes.
        </li>
        <li>
          <strong>PEDI: </strong>
          0.2 mL/kg (up to 10 mL) slow IV/IO over 5 minutes.
        </li>
      </ul>
    </li>
    <li>
      Sodium thiosulfate 25%:
      <ul>
        <li>
          <strong>ADULT: </strong>
          50 mL IV/IO.
        </li>
        <li>
          <strong>PEDI: </strong>
          5 mL Sodium Thiosulfate per 1 mL Sodium Nitrate given.
        </li>
        <strong>NOTE: </strong>
        If hypotension develops, STOP all nitrites, treat for
        shock, and consider administration of norepinephrine or
        dopamine.
      </ul>
    </li>
    <li>
      Hydroxocobalamin
      <ul>
        <li>
          <strong>ADULT: </strong>
          5 g IV/IO over 15 minutes
        </li>
        <li>
          <strong>PEDI: </strong>
          70 mg/kg (to maximum 5 g) IV/IO over 15 minutes
        </li>
      </ul>
    </li>
    <li>
      Glucagon
      <ul>
        <li>
          <strong>ADULT: </strong>
          1 – 5 mg IV/IO/IM for beta-blocker or calcium-channel blocker
          overdose.
        </li>
        <li>
          <strong>PEDI: </strong> 
          0.5 or 1 mg IV/IO/IM (per online Medical Control).
        </li>
      </ul>
    </li>
    If suspected or confirmed nerve agent exposure, treat per protocol.
    <MyLink to="/sections/2/2.09-nerve-agent-orgranophosphate-poisoning" mdxType="MyLink">
      2.09 Nerve Agent / Organophosphate Poisoning
    </MyLink>
  </ul>
    </EMTLevel>
    <Caution id="caution-1" mdxType="Caution">
  Poison Control may be reached at: <a href="tel:800-222-1222">800-222-1222</a>
    </Caution>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      